module.exports = __webpack_public_path__ + "static/media/article14.ba229dff.webp";